import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography, Grid } from '@mui/material';
import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';

export type AlertInfoPropsType = {
  text: string
  isOpen: boolean
  isActive: boolean
  createNewTask: () => void
}

export const AlertInfoSaveTask = (props: AlertInfoPropsType) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOnOK = () => {
    setOpen(false);
  }
  const onSend = () => {
    if (!props.isOpen) {
      props.createNewTask()
    } else {
      setOpen(true)
    }
  }

  return (
    <Grid item md={4} xs={12} >
      <div style={{ float: 'right' }}>
        <div>
          <Typography onClick={onSend}
            variant='caption' className={props.isActive ? 'saveButtonActive' : 'saveButton'}
            style={{ display: 'inline-flex', alignItems: 'self-end' }}>
            <SaveIcon />
            <span>Save</span>
          </Typography>

          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ display: "flex", alignItems: "center" }}>
              <WarningOutlinedIcon color="warning" fontSize='large' style={{ paddingRight: '14px' }} />
              {" "}
              {props.text}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {/* <Button onClick={handleClose} color="primary">
            Cancel
          </Button> */}
              <Button onClick={handleCloseOnOK} variant="contained" color="info" autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </Grid>
  );
}
